var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup716(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7,
    fill: "#F1EDFF",
    stroke: "#E3DCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 9.75H12.1501C11.3101 9.75 10.8897 9.75 10.5689 9.91349C10.2866 10.0573 10.0573 10.2866 9.91349 10.5688C9.75 10.8897 9.75 11.3101 9.75 12.1501V17.8501C9.75 18.6902 9.75 19.1101 9.91349 19.4309C10.0573 19.7131 10.2866 19.9429 10.5689 20.0866C10.8894 20.25 11.3092 20.25 12.1477 20.25H17.8523C18.6907 20.25 19.11 20.25 19.4305 20.0866C19.7128 19.9429 19.9429 19.7129 20.0866 19.4307C20.25 19.1101 20.25 18.6907 20.25 17.8523V16.5M21 12.75V9M21 9H17.25M21 9L15.75 14.25",
    stroke: "#5B489D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup716);
export default __webpack_public_path__ + "static/media/Group 716.6d64f59a7dfdfdfaf7e369d52948123c.svg";
export { ForwardRef as ReactComponent };